module.exports = __webpack_public_path__ + "img/virginie-isambart.661f3d57.jpg";